
// @ts-ignore
import("./Bootstrap")